// @ts-nocheck
import { lazy, createElement } from "react";
import { Button, Result } from "antd";
import { createBrowserRouter, Navigate, useRouteError } from "react-router-dom";
import Panel from "../pages/Panel";
import NewVideo from "../pages/NewVideo";
import EditVideo from "../pages/EditVideo";
import ListVideo from "../pages/ListVideo";
import ListWalletTransaction from "../pages/Finance";
import Withdraw from "../pages/Finance/withdraw";
import Settings from "../pages/Settings";
import AuthCallback from "../pages/AuthCallback";
import Contract from "../pages/Contract";
import ConnectTelegram from "../pages/ConnectTelegram";
import { DISABLE_UPLOAD, IS_WHITE_LABEL } from ".";
import useOrg from "../hooks/apis/useOrg";

function UploadFeatureGuard({ children }) {
  const { data: org, isLoading } = useOrg();
  if (isLoading || !org) return null;
  if ((org.config?.whiteLabel ?? IS_WHITE_LABEL) || DISABLE_UPLOAD) {
    return createElement(Navigate, { to: "/finance", replace: true });
  }
  return children;
}

function HomeRoute() {
  const { data: org, isLoading } = useOrg();
  if (isLoading || !org) return null;
  return (org.config?.whiteLabel ?? IS_WHITE_LABEL) || DISABLE_UPLOAD
    ? createElement(ListWalletTransaction)
    : createElement(ListVideo);
}

function RouteError() {
  const error = useRouteError() as Error;
  return createElement(
    "div",
    { style: { display: "flex", justifyContent: "center", alignItems: "center", minHeight: "100vh" } },
    createElement(Result, {
      status: "500",
      title: "خطایی رخ داد",
      subTitle: error?.message,
      extra: createElement(Button, { type: "primary", onClick: () => window.location.reload() }, "بارگذاری مجدد"),
    })
  );
}

const Marketplace = lazy(() => import("../pages/Marketplace"));
const Product = lazy(() => import("../pages/Marketplace/Product"));
const ZarinpalCallback = lazy(() => import("../pages/ZarinpalCallback"));
const Orders = lazy(() => import("../pages/Orders"));
const Loans = lazy(() => import("../pages/Loans"));
const Channels = lazy(() => import("../pages/Channels"));

const Router = createBrowserRouter([
  {
    path: "/auth/callback",
    Component: AuthCallback,
  },
  {
    path: "/",
    Component: Panel,
    ErrorBoundary: RouteError,
    children: [
      {
        path: "/videos/new",
        element: createElement(UploadFeatureGuard, null, createElement(NewVideo)),
      },
      {
        path: "/videos",
        element: createElement(UploadFeatureGuard, null, createElement(ListVideo)),
      },
      {
        path: "/videos/:id",
        element: createElement(UploadFeatureGuard, null, createElement(EditVideo)),
      },
      {
        path: "/finance/",
        Component: ListWalletTransaction,
      },
      {
        path: "/finance/withdraw",
        Component: Withdraw,
      },
      {
        path: "/finance/advance",
        Component: Loans,
      },
      {
        path: "/settings",
        Component: Settings,
      },
      {
        path: "/channels",
        Component: Channels,
      },
      {
        path: "/contracts/:uuid",
        Component: Contract,
      },
      {
        path: "/connect-telegram",
        Component: ConnectTelegram,
      },
      {
        path: "/marketplace",
        Component: Marketplace,
      },
      {
        path: "/marketplace/products/:id",
        Component: Product,
      },
      {
        path: "/marketplace/zarinpal/callback",
        Component: ZarinpalCallback,
      },
      {
        path: "/orders",
        Component: Orders,
      },
      {
        path: "/",
        Component: HomeRoute,
      },
    ],
  },
]);

export default Router;
